import { extendTheme } from "@chakra-ui/react";
import podcastColors from "./colors";
import { theme as baseTheme } from "App/theme";

export const theme = extendTheme({
  ...baseTheme,
  styles: {
    global: {
      ...baseTheme.styles.global,
      h5: {
        color: "podcast.heading-text"
      },
      p: {
        color: "podcast.paragraph-text"
      },
      "html, body, #root": {
        ...baseTheme.styles.global["html, body, #root"],
        backgroundColor: "podcast.body-background"
      }
    }
  },
  colors: {
    ...baseTheme.colors,
    podcast: podcastColors
  }
});
